import React from "react";
import { Table } from "antd";
import { Axis, Chart, Geom } from "bizcharts";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";

import { Card, Tooltip, CardHeader, Typography, CardContent } from "@material-ui/core";
// @ts-ignore
import useCustomTooltip from "bx-tooltip";
import { colours } from "../../utilities/styles";
import { tooltips } from "../../constants/tooltips";

const DashboardPracticedAreaChart = (props: {
  practicedAreas: Object;
  practicedLoops: Array<{
    loop_id: number;
    loop_title: string;
    loop_count: number;
    area_id: number;
    area_name: string;
  }>;
}) => {
  const [BxChart, CustomTooltip] = useCustomTooltip.create(Chart, Tooltip);

  const practicedAreas = props.practicedAreas as any;
  const names = Object.keys(practicedAreas);
  const values = Object.values<number>(practicedAreas);
  const totalValue = values.reduce((pre, cur) => pre + cur, 0);

  const data = names.map((name) => {
    const value = practicedAreas[name] / totalValue;

    const nextLineIndex1 = name.indexOf("(") - 1;
    const nextLineIndex2 = name.indexOf("&") - 1;
    if (nextLineIndex1 > 0) {
      name = `${name.substr(0, nextLineIndex1)}\n${name.substr(nextLineIndex1).trim()}`;
    } else if (nextLineIndex2 > 0) {
      name = `${name.substr(0, nextLineIndex2)}\n${name.substr(nextLineIndex2).trim()}`;
    }

    return { name, value };
  });

  const axisLabelFormatter = { formatter: formatAxisLabel } as any;
  return (
    <Card style={{ overflow: "visible" }}>
      <CardHeader
        title={
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              padding: "8px 0 30px 20px",
            }}
          >
            <Typography variant="h6">What areas are the leaders practicing?: Total</Typography>
            <Tooltip
              title={<Typography>{tooltips.journeyTracker}</Typography>}
              aria-label="journeyChart"
            >
              <HelpOutlineIcon />
            </Tooltip>
          </div>
        }
        style={{ padding: "8px 8px 0 0" }}
      />
      <CardContent>
        <BxChart height={250} data={data} padding={[30, 20, 60, 40]} forceFit={true}>
          <Axis name="name" />
          <Axis name="value" label={axisLabelFormatter} />
          <CustomTooltip>
            {(title: string, items: Array<any>) => {
              const areaName = title.replace("\n", " ");
              const loops = props.practicedLoops.filter((loop) => loop.area_name === areaName);
              loops.sort((a, b) => b.loop_count - a.loop_count);

              const tableData = loops.map((loop, index) => ({
                rank: index + 1,
                title: loop.loop_title,
                count: loop.loop_count,
              }));

              const columns = [
                {
                  title: "Rank",
                  dataIndex: "rank",
                },
                {
                  title: "Behavior",
                  dataIndex: "title",
                },
                {
                  title: "Count",
                  dataIndex: "count",
                  align: "right",
                },
              ];

              return (
                <>
                  <div style={tooltipTitleStyle}>{areaName}</div>
                  <Table
                    // @ts-ignore
                    columns={columns}
                    dataSource={tableData}
                    size="small"
                    pagination={false}
                  />
                </>
              );
            }}
          </CustomTooltip>
          <Geom
            type="interval"
            position="name*value"
            color={["value", colours.yomento_purple]}
            size={30}
          />
        </BxChart>
      </CardContent>
    </Card>
  );
};

const formatAxisLabel = (value: number) => {
  return `${Math.round(value * 100)}%`;
};

const tooltipTitleStyle: any = {
  fontSize: 14,
  paddingBottom: 10,
  paddingLeft: 16,
  fontWeight: "bold",
};

export default DashboardPracticedAreaChart;
